export default {
    host: 'https://dswisej.dyndns.org/restapi/api',
   //host: 'http://192.168.0.250/restapi/api',
    dbVersion:1,
    hasDb:false,
    dbName:'WinLift',
}

